import { QueryClient } from '@tanstack/react-query';

// One cache for the whole app. Reads stay fresh for 30 seconds, so moving
// between pages renders instantly from cache and refetches in the background.
// Writes invalidate their entity family (see api/queries.js), so every list,
// board and detail view of that entity refreshes without a reload — which is
// also how a change the assistant makes later will reach the page it affects.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});
